"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Title = function Title(_a) {
  var className = _a.className,
      children = _a.children,
      level = _a.level,
      size = _a.size,
      weight = _a.weight;
  className = className || "";
  level = level || "h1";
  size = size || "small";
  weight = weight || "normal";

  switch (level) {
    case "h1":
      return react_1["default"].createElement("h1", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    case "h2":
      return react_1["default"].createElement("h2", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    case "h3":
      return react_1["default"].createElement("h3", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    case "h4":
      return react_1["default"].createElement("h4", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    case "h5":
      return react_1["default"].createElement("h5", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    case "h6":
      return react_1["default"].createElement("h6", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);

    default:
      return react_1["default"].createElement("h1", {
        className: "section-title type--pos-" + size + "-" + weight + " " + className
      }, children);
  }
};

exports["default"] = Title;